import React, { Component } from "react";
import Image from '../fragments/Image';

export default class PageAbout extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isDesktop: window.innerWidth > 960,
			isPortrait: window.innerHeight > window.innerWidth
		};
		this.handleResize = this.handleResize.bind(this);
	}

	componentDidMount() {
		window.addEventListener('resize', this.handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize);
	}

	handleResize() {
		const isDesktop = window.innerWidth > 960;
		const isPortrait = window.innerHeight > window.innerWidth;
		if (isDesktop !== this.state.isDesktop || isPortrait !== this.state.isPortrait) {
			this.setState({ isDesktop, isPortrait });
		}
	}
  	
	render () {
		const { isDesktop, isPortrait } = this.state;
		
		let block = this.props.block;
		const usePortraitImage = block && isPortrait && block.portrait_image_src;
		const imageSrc = usePortraitImage ? block.portrait_image_src : block?.image_src;
		const imageWidth = usePortraitImage ? block.portrait_image_width : block?.image_width;
		const imageHeight = usePortraitImage ? block.portrait_image_height : block?.image_height;
				
		if (block) {
									
		    return (
			    
			    <div id={block.id} className={'c-page__block c-page__block--load-effect c-page__block--about c-about'}>
			    			    		
		    		<div className="l-grid c-about__text">
		    		
		    			<div className="l-grid__col l-grid__col--l-6-12 l-grid__col--xl-5-12">

							{block.profile &&
								<div className="c-about__profile scope-text" dangerouslySetInnerHTML={{__html:block.profile}}></div>
							}

							{block.services && isDesktop &&
								<div className="c-about__services scope-text scope-text--services scope-text--faded" dangerouslySetInnerHTML={{__html:block.services}}></div>
							}
							
						</div>

						{!isDesktop &&
							<div className="l-grid__col">
								<div className="c-about__rule"></div>
							</div>
						}

						{block.services && !isDesktop &&
							<div className="l-grid__col l-grid__col--xs-6-12">
								<div className="c-about__services scope-text scope-text--services scope-text--faded" dangerouslySetInnerHTML={{__html:block.services}}></div>
							</div>
						}
						{block.contact &&
							<div className="c-about__contact l-grid__col l-grid__col--xs-6-12 l-grid__col--l-4-12 l-grid__col--l-push-1-12 l-grid__col--xl-4-12 l-grid__col--xl-push-3-12">
								<div className=" scope-text scope-text--contact" dangerouslySetInnerHTML={{__html:block.contact}}></div>
							</div>
						}
						
						<div className="l-grid__col l-grid__col--m-6-12 l-grid__col--l-push-1-12 l-grid__col--xl-push-2-12">
						
							{block.text &&
								<div className="scope-text" dangerouslySetInnerHTML={{__html:block.text}}></div>
							}
							
						</div>

						<div className="l-grid__col">
							<div className="c-about__rule"></div>
						</div>

						<div className="l-grid__col">
							{imageSrc &&
								<div className="c-about__image">
									<Image src={imageSrc} width={imageWidth} height={imageHeight} alt={'Adele Bates'} />
								</div>
							}
						</div>
		    			
		    		</div>
			    					    
			    </div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
